import { GlobalState } from '../../../types.global';
import { SurveyData } from './types';

import { selectFeatureFlags } from '../../../store/selectors';

export const selectAgeVerified = ({ surveys }: GlobalState): boolean =>
  surveys.isAgeConfirmed;

export const selectIframeUrl = ({ surveys }: GlobalState): string => surveys.data.url;

export const selectNewSurveys = ({ surveys }: GlobalState): SurveyData[] =>
  surveys.visibility.updateType === 'FETCHED' && surveys.data.list;

export const selectShouldFetch = ({ surveys, user }: GlobalState): boolean => true;
// export const selectShouldFetch = ({ surveys, user }: GlobalState): boolean =>
//   surveys.visibility.updateType === 'FETCH' && !!user.userId;

export const selectIsFirstTimeDisplayed = ({
  user,
  surveys,
}: GlobalState): boolean =>
  surveys.visibility.updatedAtTabs === user.ntpVisitCounter - 1;

export const selectIsEligible = (state: GlobalState): boolean => {
  const { user } = state;
  if (!user.shells || user.shells.shellsCounter < 10 * 100) {
    return false;
  }
  return selectFeatureFlags(state).SURVEY_CHEST;

  // const [firstId] = surveys.history.allIds;
  // return !firstId || surveys.history.byId[firstId].action === 'COMPLETED';
}
